<ion-header translucent mode='md'>
  <ion-toolbar>
    <ion-title>{{ 'materialsModal.modalTitle' | translate }} </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">{{ 'materialsModal.closeButton' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <ion-row class="border-bottom">
    <ion-col class="ion-padding-start">
      <ion-text class="section-title">{{ materialDetails.id }}</ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="5">
      <ion-text>{{ 'materialsModal.idTitle' | translate }}</ion-text>
    </ion-col>
    <ion-col>
      <ion-text>{{ materialDetails.id }}</ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="5">
      <ion-text>{{ 'materialsModal.descriptionTitle' | translate }}</ion-text>
    </ion-col>
    <ion-col>
      <ion-text>{{ materialDetails.description }}</ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="5">
      <ion-text>{{ 'materialsModal.licencePlateTitle' | translate }}</ion-text>
    </ion-col>
    <ion-col>
      <ion-text>{{ materialDetails.licencePlate }}</ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="5">
      <ion-text>{{ 'materialsModal.serialNumberTitle' | translate }}</ion-text>
    </ion-col>
    <ion-col>
      <ion-text>{{ materialDetails.serialNumber }}</ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="5">
      <ion-text>{{ 'materialsModal.maintenanceDate' | translate }}</ion-text>
    </ion-col>
    <ion-col>
      <ion-text>{{ materialDetails.maintenanceDate | date : 'd-M-y' }}</ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-button [disabled]="!showChecklistButton" (click)="onChecklistButtonClick()" expand="block">{{
        'materialsModal.checklistButton' | translate
      }}</ion-button>
    </ion-col>
  </ion-row>
</ion-content>
